import { notify } from '@Support/notify';

export const defaultComparisonConfig = {
    key: 'comparison',
    activeClass: 'is-active',
    onAdd: function($self) {
        notify({
            type: 'storageItem',
            content: __('add_to_comparison_msg'),
            $target: $self.get(0)
        });
        notify({
            type: 'header',
            content: __('add_to_comparison_msg')
        });

        ICube.data.set('comparisonChanged', true);
    },
    onRemove: function() {
        ICube.data.set('comparisonChanged', true);
    }
}